import React, { useContext, useEffect, useState } from "react";
import { Container, Alert, Row, Col, Form } from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";
import { logActivity } from "../../utils/LogActivity";
import Preloader from "../../shared/PreLoaders";
import { Authorization } from "../../Context/Authorization";

const ManageLoanRepayment = () => {
  const [loanData, setLoanData] = useState([]);
  const [error, setError] = useState(null);
  const [vfcOption, setVfcOption] = useState([]);
  const [selectedVfc, setSelectedVfc] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const { access, userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchVfc = async () => {
      setLoading(true);
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, config);
        const data = response.data.vfcs;
        if (Array.isArray(data)) {
          setVfcOption(data);
        } else {
          console.error("API did not return an array", data);
        }
      } catch (error) {
        console.log("Error fetching VFC data", error);
      }
      setLoading(false);
    };

    fetchVfc();
  }, [Api, access]);

  const fetchLoanCollections = async () => {
    if (!selectedVfc) {
      setError("Please select a VFC.");
      setLoanData([]);
      return;
    }
    setLoading(true);
    try {
      const config = Authorization();
      const response = await axios.post(
        `${Api}/api/loan-collections/get-loancollection-by-vfc-date`,

        {
          vfcId: selectedVfc,
          date: selectedDate, // Controller will handle an empty date appropriately
        },
        config
      );
      const filteredLoanCollections = response.data.data;
      if (filteredLoanCollections.length > 0) {
        setLoanData(filteredLoanCollections);
        setError(null);
      } else {
        setLoanData([]);
        setError("No loan repayment found for the selected criteria.");
      }
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
    await logActivity(
      userId,
      "Viewed Loan Collection",
      "Manage Loan Repayment Page",
      Api
    );
  };

  const handleVfcChange = (e) => {
    setSelectedVfc(e.target.value);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleSearch = () => {
    fetchLoanCollections();
  };

  // Function to adjust the paymentDate to local time
  const formatToLocalTime = (dateString) => {
    const date = new Date(dateString);
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
  };

  return (
    <Container className="my-4">
      <Preloader loading={loading} />

      <div className="page-header">
        <h3 className="page-title">Loan Repayments</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Loan Repayments
            </li>
          </ol>
        </nav>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Select VFC</Form.Label>
                  <Form.Control
                    as="select"
                    value={selectedVfc}
                    onChange={handleVfcChange}
                  >
                    <option value="">Select VFC</option>
                    {vfcOption.map((vfc) => (
                      <option key={vfc._id} value={vfc._id}>
                        {vfc.vfcName}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Select Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="d-flex align-items-end">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-md"
                  onClick={handleSearch}
                >
                  Search
                </button>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row icons-list">
            <div className="Table_data">
              <table className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Loan No</th>
                    <th>Loan Type</th>
                    <th>Amount</th>
                    <th>Interest</th>
                    <th>Payment Date</th>
                    <th>VFC Name</th>
                  </tr>
                </thead>
                <tbody>
                  {loanData.map((loan, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{loan.loanId?.loanNo || "N/A"}</td>
                      <td>{loan.loanId?.loanType?.loanName || "N/A"}</td>
                      <td>{loan.amountPaid}</td>
                      <td>{loan.interestPaid}</td>
                      <td>{formatToLocalTime(loan.paymentDate)}</td>
                      <td>{loan.loanId?.vfcId?.vfcName || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ManageLoanRepayment;
